var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1275,
    height: 1275,
    viewBox: "0 0 1275 1275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_3201_743)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 637.5,
    cy: 637.5,
    r: 261.5,
    fill: "#990CE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter1_f_3201_743)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.531,
    cy: 637.213,
    rx: 170.383,
    ry: 170.381,
    fill: "#D500FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3201_743",
    x: 0.945221,
    y: 0.945221,
    width: 1273.11,
    height: 1273.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187.527,
    result: "effect1_foregroundBlur_3201_743"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3201_743",
    x: 359.99,
    y: 359.674,
    width: 555.083,
    height: 555.079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 53.5793,
    result: "effect1_foregroundBlur_3201_743"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMcp);
export default __webpack_public_path__ + "static/media/light-mcp.ba75ea79e5757f90f963bf8042c62cce.svg";
export { ForwardRef as ReactComponent };